import axios from "axios";
import { authHeaders } from "./AuthState";
import { buildApiUrl } from "./Static";

const serverMessage = (error) => {
  const data = error?.response?.data;
  return (
    (typeof data === "string" && data) ||
    data?.message ||
    data?.error ||
    data?.msg ||
    ""
  );
};

export async function requestPasswordReset(email) {
  const { data } = await axios.post(buildApiUrl("/user/forgot-password"), {
    email: String(email || "").trim().toLowerCase(),
  });
  return data;
}

export async function resetPassword({ token, password }) {
  const { data } = await axios.post(buildApiUrl("/user/reset-password"), {
    token,
    password,
  });
  return data;
}

export async function changePassword({ currentPassword, password }) {
  const { data } = await axios.put(
    buildApiUrl("/user/password"),
    {
      currentPassword,
      password,
    },
    { headers: authHeaders() },
  );
  return data;
}

export const passwordErrorMessage = (error, fallback) => {
  const status = error?.response?.status;
  const message = serverMessage(error);

  if (status === 404 || /<!DOCTYPE html/i.test(message) || /cannot post/i.test(message)) {
    return "Password reset is not live on this API yet. Use the local API or deploy the new password routes.";
  }

  if (typeof message === "string" && message.trim()) {
    return message;
  }

  if (status === 401) {
    return "Current password is incorrect.";
  }

  if (error?.message === "Network Error") {
    return "Unable to reach the password service. Try again in a moment.";
  }

  return fallback || "Unable to update this password. Please try again.";
};
